import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Label,
} from "recharts";

const SecondBarChart = ({ disbursementStatistics }) => {
  return (
    <ResponsiveContainer width="98%" height={280}>
      <BarChart
        data={disbursementStatistics}
        margin={{ top: 0, right: 10, left: 15, bottom: 10 }}
      >
        <XAxis
          dataKey="month"
          axisLine={{ stroke: "#D9D9D9" }}
          tickFormatter={(value) => String(value).slice(0, 3)}
        >
          <Label value="Months" position="insideBottom" offset={-10} />
        </XAxis>
        <YAxis
          domain={[0, 300000]}
          ticks={[0, 75000, 150000, 225000, 300000]}
          axisLine={{ stroke: "#D9D9D9" }}
        />
        <Tooltip formatter={(value) => value.toLocaleString()} />
        <Bar dataKey="totalDisbursed" fill="#074073" />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default SecondBarChart;
